import React from "react";
import PageContentStyle from "../../../assets/css/components/admin/menus/PageContent.css";
import NavbarAdmin from "./NavbarAdmin";
import ScrollToTop from "../../general/ScrollToTop";
export default function PageContent(props) {
  return (
    <PageContentStyle>
      <main className="page-content">
        <NavbarAdmin role={props.role}/>
        {props.children}
        <ScrollToTop />
      </main>
    </PageContentStyle>
  );
}
